<template>
  <!--
    O App.vue agora contém apenas o <router-view>.
    Este componente especial do vue-router irá renderizar automaticamente
    o componente correto (TelaLogin, MainDashboard, etc.) com base na URL atual.
  -->
  <router-view />
</template>

<script setup>
import { onMounted, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

const authStore = useAuthStore()
const router = useRouter()

let intervalId = null

const rotasPublicas = ['Login', 'RecuperarSenha', 'RedefinirSenha', 'ValidacaoSucesso', 'ValidacaoFalhou']

const verificarExpiracaoToken = async () => {
  const tokenAtual = localStorage.getItem('authToken')
  const nomeRotaAtual = router.currentRoute.value.name

  if (!tokenAtual) {
    if (nomeRotaAtual && !rotasPublicas.includes(nomeRotaAtual)) {
      console.warn('[App.vue] Token ausente detectado via monitor. Redirecionando...')
      authStore.limparSessaoLocal()
      router.push({ name: 'Login', query: { sessaoExpirada: 'true' } })
    }
    return
  }

  try {
    const payload = JSON.parse(atob(tokenAtual.split('.')[1]))
    const nowInSeconds = Math.floor(Date.now() / 1000)
    const expiraEm = payload.exp

    // Se o token já expirou, tenta renovar automaticamente
    if (expiraEm && expiraEm < nowInSeconds) {
      console.warn('[App.vue] Token expirado detectado. Tentando renovação automática...')
      try {
        await authStore.refreshAccessToken()
        console.log('[App.vue] Token renovado com sucesso após expiração.')
        return
      } catch (e) {
        console.warn('[App.vue] Renovação automática falhou. Redirecionando...')
        authStore.limparSessaoLocal()
        if (!rotasPublicas.includes(router.currentRoute.value.name)) {
          router.push({ name: 'Login', query: { sessaoExpirada: 'true' } })
        }
        return
      }
    }

    // Se falta menos de 5 minutos para expirar, renova preventivamente
    if (expiraEm && expiraEm < nowInSeconds + 300) {
      console.log('[App.vue] Token próximo de expirar. Renovando preventivamente...')
      try {
        await authStore.refreshAccessToken()
        console.log('[App.vue] Token renovado preventivamente com sucesso.')
      } catch (e) {
        console.warn('[App.vue] Renovação preventiva falhou. Redirecionando...')
        authStore.limparSessaoLocal()
        if (!rotasPublicas.includes(router.currentRoute.value.name)) {
          router.push({ name: 'Login', query: { sessaoExpirada: 'true' } })
        }
      }
    }
  } catch (e) {
    console.error('[App.vue] Erro ao verificar expiração:', e)
  }
}

onMounted(() => {
  // ESCUTADOR DE STORAGE NO APP.VUE: Evita importação circular no auth.js
  // Se o token sumir em outra aba ou no F12, o App.vue percebe e redireciona
  window.addEventListener('storage', (event) => {
    if (event.key === 'authToken' && !event.newValue) {
      verificarExpiracaoToken()
    }
  })

  // Verifica a cada 10 segundos (mais preciso que 30s para renovação preventiva)
  intervalId = setInterval(verificarExpiracaoToken, 10000)
  // Verifica imediatamente ao montar
  verificarExpiracaoToken()
})

onUnmounted(() => {
  if (intervalId) clearInterval(intervalId)
})
</script>

<style>
/* Aqui ficam apenas os estilos verdadeiramente globais.
  Todos os estilos de layout do dashboard foram movidos para MainDashboard.vue.
*/
html, body {
  height: 100%;
  margin: 0;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
</style>
